import { Navigate, Outlet } from 'react-router-dom';
import { RestaurantStatus } from '@shared/types/restaurants';
import { useRestaurantLoaderData } from 'webReservations/hooks/useRestaurantLoaderData';
import { LANDING_PATH } from 'webReservations/paths';

export const IsDiscoverable = () => {
  const restaurant = useRestaurantLoaderData();

  if (!restaurant) {
    return <Outlet />;
  }

  const { status } = restaurant;

  return status === RestaurantStatus.Archived ? (
    <Navigate to={LANDING_PATH} />
  ) : (
    <Outlet />
  );
};
